import { colors } from '@ardoq/design-tokens';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';

export const DropdownFootnote = ({ text }: { text: string }) => (
  <>
    <FlexBox gap="xsmall" align="center" paddingX="medium" paddingY="small">
      <Icon
        iconName={IconName.INFO}
        iconSize={IconSize.SMALL}
        color={colors.textSubtle}
      />
      <Text variant="text2" color="textSubtle">
        {text}
      </Text>
    </FlexBox>
  </>
);
